import "./App.css";
import Layout from "./Layout";
import ModelBackgroundPage from "./containers/ModelBackgroundPage/ModelBackgroundPage";
import Queue from "./containers/Queue/Queue";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ModelToModel from "./containers/ModelToModel/ModelToModel";
import MannequinToModel from "./containers/MannequinToModel/MannequinToModel";
import VirtualTryOn from "./containers/VirtualTryOn/VirtualTryOn";
import ComparisonTable from "./containers/ComparisonTable/ComparisonTable";
import CalculationSheet from "./containers/CalculationSheet/CalculationSheet";
import Login from "./containers/Login/Login";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import NotFound from "./containers/NotFound/NotFound";
import OfflineBoundary from "./components/OfflineBoundary/OfflineBoundary";
import ProductListing from "./containers/ProductListing/ProductListing";
import BackgroundListing from "./containers/BackgroundListing/BackgroundListing";
import ModelListing from "./containers/ModelListing/ModelListing";
import CategoryListing from "./containers/CategoryListing/CategoryListing";
import { Toaster } from "react-hot-toast";

function App() {
  const { isAuthenticated, token } = useSelector((state) => state.auth);
  const isLoggedIn = Boolean(isAuthenticated || token);

  return (
    <OfflineBoundary>
      <Toaster
        position="top-center"
        containerStyle={{
          top: 48,
          zIndex: 999999,
        }}
        toastOptions={{
          duration: 2200,
          style: {
            background: "#ffffff",
            color: "#1A2030",
            border: "1px solid #C4CAD6",
            borderRadius: "10px",
            fontSize: "13px",
            fontWeight: "600",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.03)",
            zIndex: 999999,
          },
          success: {
            iconTheme: {
              primary: "#10b981",
              secondary: "#ffffff",
            },
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#ffffff",
            },
          },
        }}
      />
      <Routes>
        <Route
          path="/"
          element={isLoggedIn ? <Navigate to="/playground" replace /> : <Login />}
        />
        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/playground" replace /> : <Login />}
        />

        {/* Standalone Not Found page (outside Layout) */}
        <Route path="/not-found" element={<NotFound />} />

        <Route element={<Layout />}>
          {/* Studio Assets (Admin & Superadmin) */}
          <Route
            path="/studio-assets"
            element={<Navigate to="/studio-assets/products" replace />}
          />
          <Route
            path="/studio-assets/products"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin"]}>
                <ProductListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/studio-assets/backgrounds"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin"]}>
                <BackgroundListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/studio-assets/models"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin"]}>
                <ModelListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/studio-assets/categories"
            element={
              <ProtectedRoute allowedRoles={["admin", "superadmin"]}>
                <CategoryListing />
              </ProtectedRoute>
            }
          />

          <Route
            path="/playground"
            element={
              <ProtectedRoute>
                <ModelBackgroundPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/queue"
            element={
              <ProtectedRoute>
                <Queue />
              </ProtectedRoute>
            }
          />
          <Route
            path="/show-tell"
            element={<Navigate to="/show-tell/model-to-model" replace />}
          />
          <Route
            path="/show-tell/model-to-model"
            element={
              <ProtectedRoute>
                <ModelToModel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/show-tell/mannequin-to-model"
            element={
              <ProtectedRoute>
                <MannequinToModel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/show-tell/virtual-try-on"
            element={
              <ProtectedRoute>
                <VirtualTryOn />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comparison"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <ComparisonTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calculation-sheet"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <CalculationSheet />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Any unknown route redirects to /not-found */}
        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Routes>
    </OfflineBoundary>
  );
}

export default App;
